<template>
    <div>
        <div class="item">
            <div class="name">
                {{ scan_action_prototype.name }}
            </div>
            <div class="barcode">
                <barcode
                    :value="'@@'+scan_action_prototype.barcode+'@@'"
                    :tag="'svg'"
                    :options="{
                        background: 'transparent',
                        displayValue: false,
                        format: 'CODE128',
                        width: '5vw',
                        height: '120vh'
                    }">
                    看見此資訊請通知系統工程師。
                </barcode>
            </div>
            <div class="barcode_name">
                {{ scan_action_prototype.barcode }}
            </div>
        </div>
        <div class="divided"></div>

    </div>
</template>

<script>
import VueBarcode from '@chenfengyuan/vue-barcode'

export default {
    props: {
        scan_action_prototype: Object
    },
    data() {
        return {
        }
    },
    computed: {
        env() {
            return ENV.NODE_ENV
        }
    },
    created() {
    },
    mounted() {
    },
    watch: {
    },
    methods: {
    },
    components: {
        'barcode': VueBarcode
    }
}
</script>

<style scoped lang="scss">
    .item {
        & {
            position: relative;
            width: 100%;
            top: 38vh;
        }
        .name, .barcode, .barcode_name {
            text-align: center;
        }
        .name {
            font-size: 10vw;
        }
        .barcode {
            padding-top: 6vw;
        }
        .barcode_name {
            font-size: 5vw;
            padding-top: 2vw;
        }
    }
</style>
